<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <br>
  <div class="main-content">

    <ng-container *ngIf="loadingData === true">
      <div style="display: flex; align-self: center; height: 30vh; width: 100%;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </ng-container>

    <div class="container-fluid" *ngIf="loadingData === false && userData">
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="card card-profile">
            <div class="card-avatar">
              <a href="javascript:void(0)">
                <img class="img" [src]="userData.img" />
              </a>
            </div>
            <div class="card-body">
              <h6 class="card-category text-gray">Grupo: {{ (userData && userData.group && userData.group[0]) ? userData.group[0].name : 'Sin grupo' }}</h6>
              <h4 class="card-title">{{ userData.name }} {{ userData.lastname }}</h4>
              <div class="card-description">
                <div class="goal-container" style="flex-direction: column; margin-bottom: 1rem;">
                  <p class="icon-label"> <mat-icon svgIcon="targetSvg"></mat-icon> Meta personal:</p>
                  <p>
                    {{ (userData.goal) ? userData.goal : '--' }}
                  </p>
                </div>
              </div>
              <p class="card-description">
                <b>Activo:</b> {{ (userData.active && userData.active === 1) ? 'Activo' : 'Inactivo' }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <div class="card" style="height: 100%;">
            <div class="card-header card-header-danger">
              <h4 class="card-title">Datos del Perfil | Solo Lectura</h4>
            </div>
            <div class="card-body">
              <form>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Nombre" readonly [value]="userData.name">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Apellidos" readonly [value]="userData.name">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Email" type="email" readonly [value]="userData.email">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Teléfono" type="tel" readonly [value]="userData.telephone">
                    </mat-form-field>
                  </div>
                </div> <!-- Personal Data -->

                <div class="row">
                  <div class="col-md">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Peso" type="text" [value]="userData.weight" readonly>
                    </mat-form-field>
                  </div>
                  <div class="col-md">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Altura" type="text" [value]="userData.height" readonly>
                    </mat-form-field>
                  </div>

                  <div class="col-md">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Cintura" type="text" [value]="userData.waist" readonly>
                    </mat-form-field>
                  </div>
                </div> <!-- medidas -->

                <div class="clearfix"></div>
              </form>

              <form>
                <hr>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input maxlength="45" matInput placeholder="Recomendación" type="text" [(ngModel)]="recomendation" [ngModelOptions]="{standalone: true}">
                      <button style="margin-bottom: 12px;" mat-raised-button  matSuffix color="primary" (click)="saveRecomendation()">
                        <mat-icon>save</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</mat-dialog-content>
<!-- <hr>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions> -->
